<template>
  <div>
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="12">
          <a-col :md="6" :sm="8">
            <a-form-item :label="$t(I18N_KEY.ORDER + 'queryDate')">
              <a-date-picker v-model='queryParam.date' format='YYYY-MM-DD' value-format="YYYY-MM-DD"
                style='width: 100%;' />
            </a-form-item>
          </a-col>

          <a-col :md='6' :sm='8'>
            <a-form-item :label="$t(I18N_KEY.COLLECTION + 'normalConfig')">
              <a-select v-model='queryParam.normalConfigId' allowClear>
                <!-- 情况1：未选分组 → 展示全部阶段 -->
                <template v-if="!queryParam.groupId">
                  <a-select-option v-for='item in normalConfigList' :key='item.id' :value='item.id'>
                    {{ item.name }}
                  </a-select-option>
                </template>

                <!-- 情况2：已选分组 → 只展示联动出来的那一条 -->
                <template v-else>
                  <a-select-option
                    v-if="linkedNormalConfig && linkedNormalConfig.id !== undefined && linkedNormalConfig.id !== null"
                    :key="linkedNormalConfig.id" :value="linkedNormalConfig.id">
                    {{ linkedNormalConfig.name }}
                  </a-select-option>
                </template>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md='6' :sm='8'>
            <a-form-item :label="$t(I18N_KEY.COLLECTION + 'grouping')">
              <a-select v-model='queryParam.groupId' allowClear @change="onChangeGroup">
                <a-select-option v-for='item in groupList' :key='item.id' :value="item.id">
                  {{ item.groupName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <!-- 催收员 -->
          <a-col :md="6" :sm="8">
            <a-form-item :label="$t(I18N_KEY.COLLECTION + 'debtCollector')">
              <a-select v-model='queryParam.userId' showSearch optionFilterProp="children" allowClear
                :notFoundContent="$t(I18N_KEY.COLLECTION + 'noData')">
                <a-select-option v-for="item in userIdList" :key="item.id" :value="item.id">
                  {{ item.mobile }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <span style="float: left; overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('search') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('reset')
                }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <a-table ref="table" rowKey="id" size="middle" bordered :columns="columns" :dataSource="dataSource"
      :pagination="false" :loading="loading" @change="handleTableChange">
    </a-table>

    <div style="margin-top: 15px; text-align: right;">
      <v-pagination v-if="total" :page-num="form.pageNum" :page-size="form.pageSize" :total="total"
        @change="handleTableChange" />
    </div>
  </div>
</template>

<script>
import { filterObj } from '@/utils/util'
import vPagination from '../modules/pagination'
import moment from 'moment'
import { collectionPerformanceByStageOfUser } from '@/webpublicapi/order'
import { getCollectorMobile } from '@/webpublicapi/collection'
import { getSysGroup } from '@/webpublicapi/platformCollection'
import { getAllNormalConfig } from '@/webpublicapi/normalConfig'
import { getColUserList } from '@/api/system'

const I18N_KEY = {
  ORDER: 'order.',
  COLLECTION: 'collection.'
}

export default {
  name: 'CollectionUserSchedule',
  components: {
    vPagination
  },
  data() {
    return {
      total: 0,
      I18N_KEY,
      linkedNormalConfig: null,
      userIdList: [],
      groupList: [],
      normalConfigList: [],
      queryParam: {
        // date: [],
        date: null,
        groupId: null,
        userId: null,
        normalConfigId: null
      },
      dataSource: [],
      loading: false,
      form: {
        pageNum: 1,
        pageSize: 10
      }
    }
  },
  computed: {
    columns() {
      return [
        {
          title: '催收阶段',
          align: 'center',
          dataIndex: 'configName'
        },
        {
          title: '组名',
          align: 'center',
          dataIndex: 'groupName'
        },
        {
          title: '催收员账号',
          align: 'center',
          dataIndex: 'mobile'
        },
        // {
        //   title: '催收分单总数',
        //   align: 'center',
        //   dataIndex: 'totalNum'
        // },
        {
          title: '有效单数',
          align: 'center',
          dataIndex: 'totalValidNum'
        },
        {
          title: '持单数',
          align: 'center',
          dataIndex: 'holdTaskNum'
        },
        {
          title: '当日分单数',
          align: 'center',
          dataIndex: 'currentTaskNum'
        },
        // {
        //   title: '实际催回笔数',
        //   align: 'center',
        //   dataIndex: 'realSuccessNum'
        // },
        // {
        //   title: '实际催回金额',
        //   align: 'center',
        //   dataIndex: 'realSuccessAmout'
        // },
        {
          title: '当日催回笔数',
          align: 'center',
          dataIndex: 'currentSuccessNum'
        },
        {
          title: '当日催回金额',
          align: 'center',
          dataIndex: 'currentSuccessAmout'
        },
        // {
        //   title: '实际展期笔数',
        //   align: 'center',
        //   dataIndex: 'realExCount'
        // },
        // {
        //   title: '实际展期金额',
        //   align: 'center',
        //   dataIndex: 'realExAmount'
        // },
        {
          title: '当日展期笔数',
          align: 'center',
          dataIndex: 'currentExCount'
        },
        {
          title: '当日展期金额',
          align: 'center',
          dataIndex: 'currentExAmount'
        },
        {
          title: '催回率',
          align: 'center',
          dataIndex: 'successColRate'
        }
      ]
    }
  },
  created() {
    getSysGroup().then(res => {
      this.groupList = res.data || []
    });
    getAllNormalConfig().then(res => {
        this.normalConfigList.push({
            'name': 'ALL',
            'id': '',
            'value': ''
        });
        res.data.forEach(item => {
            this.normalConfigList.push(item)
        })
    });
    this.loadCollectorList();
    this.loadData(1)
  },
  methods: {
    handleTableChange(pageNum, pageSize) {
      this.form.pageNum = pageNum
      this.form.pageSize = pageSize
      this.search()
    },
    loadCollectorList() {
      return getCollectorMobile().then(res => {
          this.userIdList = [];   // 先清空，避免重复 push
          const keys = Object.keys(res.data || {});
          for (const key of keys) {
              this.userIdList.push({
                  mobile: key,
                  id: res.data[key]
              });
          }
      });
    },
    search() {
      this.loading = true
      const params = this.getQueryParams()
      collectionPerformanceByStageOfUser(Object.assign({}, params)).then((res) => {
        if (res.code === 1000) {
          this.total = res.data.total
          this.dataSource = res.data.list
        } else {
          this.total = 0
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false
        this.$message.error(e.message)
      })
    },
    searchQuery() {
      this.loadData(1)
    },
    loadData(arg) {
      if (arg === 1) {
        this.form.pageNum = 1
      }
      this.loading = true
      const params = this.getQueryParams()
      collectionPerformanceByStageOfUser(Object.assign({}, params)).then((res) => {
        if (res.code === 1000) {
          this.total = res.data.total
          this.dataSource = res.data.list
        } else {
          this.total = 0
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false
        this.$message.error(e.message)
      })
    },
    transformTime(time) {
      return moment(time).format('YYYY-MM-DD')
    },
    getQueryParams() {
      const { date } = this.queryParam;
      const param = {
        ...this.queryParam,
        queryDate: date,
        // queryStartDate: (date && date.length) ? this.transformTime(date[0]) : undefined,
        // queryEndDate: (date && date.length) ? this.transformTime(date[1]) : undefined,
        pageNum: this.form.pageNum,
        pageSize: this.form.pageSize
      }
      delete param.date;
      return filterObj(param)
    },
    onChangeGroup(groupId) {
        // 1. 清空联动状态
        this.linkedNormalConfig = null
        this.queryParam.normalConfigId = undefined
        this.userIdList = []
        this.queryParam.keyword = null

        if (!groupId) {
            // 清空分组 → 阶段框回到"全部阶段"模式，催收员回到"暂无数据"
            return
        }

        // 2. 从 groupList 找到该组，取 collectionLevel
        const targetGroup = this.groupList.find(g => String(g.id) === String(groupId))
        if (!targetGroup) {
            return
        }

        // 3. 用 collectionLevel 匹配 normalConfigList 的 id → 取 name
        const level = targetGroup.collectionLevel
        if (level !== undefined && level !== null && level !== '') {
            const matchedConfig = this.normalConfigList.find(
                c => String(c.id) === String(level)
            )
            if (matchedConfig) {
                this.linkedNormalConfig = {
                    id: matchedConfig.id,
                    name: matchedConfig.name
                }
                this.queryParam.normalConfigId = matchedConfig.id
            }
        }

        // 4. 加载该组催收员
        getColUserList({
            pageNum: 1,
            pageSize: 1000,
            userstatus: "1",
            groupIdP: groupId
        }).then(res => {
            const rows = (res && res.data && res.data.rows) ? res.data.rows : []
            this.userIdList = rows
        }).catch(e => {
            this.userIdList = []
            this.$message.error(e.message || 'query collector fail')
        })
    },
    searchReset() {
      this.queryParam.date = null
      this.queryParam.groupId = undefined
      this.queryParam.normalConfigId = undefined
      this.queryParam.userId = undefined
      this.form.pageNum = 1
      this.linkedNormalConfig = null
      this.userIdList = []
      this.loadCollectorList();
      this.loadData(1)
    }
  }
}
</script>

<style lang="less" scoped>
@import "~@/assets/less/common.less";
</style>